import { render, staticRenderFns } from "./orderUpdate.vue?vue&type=template&id=5be55fed&scoped=true"
import script from "./orderUpdate.vue?vue&type=script&lang=js"
export * from "./orderUpdate.vue?vue&type=script&lang=js"
import style0 from "./orderUpdate.vue?vue&type=style&index=0&id=5be55fed&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be55fed",
  null
  
)

export default component.exports